import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-extension-button",
  templateUrl: "./extension-button.component.html",
  styleUrls: ["./extension-button.component.scss"],
  standalone: false,
})
export class ExtensionButtonComponent {
  constructor(private router: Router) {}

  openExtension(): void {
    void this.router.navigate(["/settings/extension"]);
  }
}
